<template>
    <div id="wrapper" :key="valuekey">
        <div class="col-xl-6">
            <div class="Chart">
                <canvas id="alerts" width="50" height="50"></canvas>
            </div>
            <div v-if="total && total > 0" style="font-size:15px; text-align:center;">
                <label>Total:</label> {{total}}
            </div>
        </div>
    </div>
</template>
            
<script>
import Chart from 'chart.js';
import Controller from './CrtAlert';
export default {
  
    name: 'Alerts',
    components: {
    },
    
    data() {
    return {
      chart: null,
      companyNumber: 0,
      total: 0,

      }
    },
    methods: Controller.methods,
    created() {
      Controller.init(this);
    },
    mounted() {

        const ctx = document.getElementById('alerts');
        this.chart = new Chart(ctx, {
          type: 'bar',
          data: {
            datasets: [{
                    data: null,
                    backgroundColor: "#AF0000",
                    
                    label:'Alertas',
                }],
                labels:['Alertas'],
        },
        options: {
        
            title: {
                display: true, 
            },
            legend: {
                fullWidth: true,
                labels: {
                    fontColor: '#000',
                    boxWidth: 20,
                },
            },
        }
      });
      this.filter();
    }
}
</script>
